import { BLOCK_DEFS } from './blockSchema.js';
import BlockRenderer from './BlockRenderer.jsx';

// What the user sees floating under their cursor while dragging.
// - Palette drags: a small chip ("New block · Heading") since there's no
//   instance to render yet.
// - Block drags: a real, scaled-down render of the block being moved so the
//   user can see what's traveling. We cap the visual width (320px) and
//   constrain height (max 220px) so big sections don't dominate the viewport.
export default function DragPreview({ kind, blockType, block }) {
  const def = BLOCK_DEFS[blockType];
  if (!def) return null;

  if (kind === 'palette' || !block) {
    return <Chip def={def} caption="New block" />;
  }

  return (
    <div
      style={{
        width: 320,
        maxHeight: 220,
        overflow: 'hidden',
        background: '#fff',
        borderRadius: 12,
        border: '1px solid rgba(91,108,255,0.5)',
        boxShadow: '0 18px 40px rgba(15,19,32,0.25)',
        transform: 'rotate(-1.5deg)',
        pointerEvents: 'none',
      }}
    >
      <div className="flex items-center justify-between border-b border-ink-200 bg-ink-50 px-3 py-1.5 text-[10px] font-semibold uppercase tracking-wider text-ink-500">
        <span>{def.label}</span>
        <span>Move</span>
      </div>
      <div
        style={{
          // Render the block at native size, then visually shrink so a
          // landing-page-sized hero still fits in the chip.
          transformOrigin: 'top left',
          transform: 'scale(0.45)',
          width: 'calc(100% / 0.45)',
        }}
      >
        <BlockRenderer blocks={[block]} />
      </div>
    </div>
  );
}

function Chip({ def, caption }) {
  return (
    <div
      className="pointer-events-none flex items-center gap-2 rounded-lg border border-brand-300 bg-white px-3 py-2 shadow-xl"
      style={{ transform: 'rotate(-2deg)' }}
    >
      <span className="grid h-7 w-7 place-items-center rounded bg-brand-50 text-sm text-brand-700">
        {def.icon}
      </span>
      <div className="text-xs">
        <div className="font-semibold text-ink-900">{def.label}</div>
        <div className="text-[10px] uppercase tracking-wider text-ink-400">
          {caption}
        </div>
      </div>
    </div>
  );
}
